import { BemHelper } from "@/utils/BemHelper";
import React from "react";

export type CtCardFeatureProps = {
  label?: string;
  value: string;
  icon?: React.ReactNode | React.ElementType;
};

const bem = new BemHelper("ct-card");

function CtCardFeature({ label, value, icon }: CtCardFeatureProps) {
  const Icon = icon as React.ElementType;
  return (
    <div className={bem.element("feature")}>
      {icon && (
        <div className={bem.element("feature-icon")}>
          <Icon style={{ fontSize: 20 }} />
        </div>
      )}
      <div className={bem.element("feature-label")}>{label}</div>
      <div className={bem.element("feature-value")}>{value}</div>
    </div>
  );
}

export default CtCardFeature;
